import React from "react";

export default function Section22() {
  const reasons = [
    {
      title: " Planning & Strategy",
      description: "We define goals, technical requirements, and user expectations, creating a roadmap that ensures smooth, focused project execution.",
    },
    {
      title: " Design & User Experience",
      description: "We craft intuitive layouts that improve navigation, engagement, and conversions across desktop, tablet, and mobile devices.",
    },
    {
      title: " Development & Testing",
      description: "Our team builds responsive websites using proven methods to ensure speed, usability, and reliable performance. ",
    },
    {
      title: "Launch & Continuous Support ",
      description: "We manage seamless launches and provide ongoing monitoring, updates, and support to keep your website secure and efficient.",
    },
   
  ];

  return (
    <div className="w-full Section12">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Our Workflow
        </h2>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {reasons.map((item, index) => (
            <div
              key={index}
              className={`p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px] ${
                index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              }`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {item.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
